import React from "react";
import axios from "axios";
import { toast } from "react-toastify";

import AuthService from "../../../services/auth.service";

const APP_URL = process.env.APP_URL;

export const DownloadPdf = () => {
  async function downloadPdfGuide() {
    let config = {
      headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
      responseType: "blob",
    };
    config.params = {
      ...{ responseType: "blob" },
    };
    await axios
      .get(`${APP_URL}/api/v6/downloads/support/pdf?support.pdf`, config)
      .then(function (response) {
        if (response?.data?.size < 100) {
          toast.error("فایل پیدا نشد", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return false;
        } else {
          const blob = new Blob([response.data], { type: "application/pdf" });
          let pdfURL = window.URL.createObjectURL(blob);
          let tempLink = document.createElement("a");
          tempLink.href = pdfURL;
          tempLink.setAttribute("download", "نکات تکمیلی رژیم چنگال.pdf");
          tempLink.click();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  return (
    <div className="w-full !mt-4 md:!mt-6">
      <button onClick={downloadPdfGuide} className="btn_support_pdf !w-full">
        دانلود فایل نکات مهم رژیم
      </button>
    </div>
  );
};
